import { runGuestXMFunctions } from '../functions/guestxm';

export const enquiryForm = () => {
    const enquiryFormElem = document.getElementById('enquiry-form');
    const feedbackTrigger = document.querySelector('.js-feedback-option-trigger');
    const locationTrigger = document.querySelector('.js-location-trigger');
    const starRating = document.querySelector('.js-star-rating');

    if (starRating) {
        const stars = starRating.querySelectorAll('.enquiry-form__star');
        const radioInputs = starRating.querySelectorAll('input[type="radio"]');

        stars.forEach((star, index) => {
            star.addEventListener('mouseenter', () => {
                stars.forEach((s, i) => {
                    if (i <= index) {
                        s.classList.add('active');
                    } else {
                        s.classList.remove('active');
                    }
                });
            });

            star.addEventListener('click', () => {
                radioInputs[index].checked = true;

                stars.forEach((s, i) => {
                    if (i <= index) {
                        s.classList.add('active');
                    } else {
                        s.classList.remove('active');
                    }
                });
            });
        });

        starRating.addEventListener('mouseleave', () => {
            const checkedIndex = Array.from(radioInputs).findIndex(input => input.checked);

            stars.forEach((s, i) => {
                if (checkedIndex >= 0 && i <= checkedIndex) {
                    s.classList.add('active');
                } else {
                    s.classList.remove('active');
                }
            });
        });
    }

    const updateNegativeExperienceFields = () => {
        const feedbackValue = feedbackTrigger ? feedbackTrigger.value : '';
        const selectedLocationId = locationTrigger ? locationTrigger.value : '';
        const groceryRangeId = '1770299538776918';
        const isNegativeExperience = feedbackValue === 'I didnt have a great experience';
        const isGroceryRange = selectedLocationId === groceryRangeId;

        if (isNegativeExperience && selectedLocationId) {
            const tellUsMoreField = document.querySelector('.js-tell-us-more-field');

            if (isGroceryRange) {
                if (tellUsMoreField) {
                    tellUsMoreField.classList.add('hidden');
                    const checkboxes = tellUsMoreField.querySelectorAll('input[type="checkbox"]');
                    checkboxes.forEach(cb => {
                        cb.checked = false;
                        cb.disabled = true;
                    });
                }
            } else {
                if (tellUsMoreField) {
                    tellUsMoreField.classList.remove('hidden');
                    const checkboxes = tellUsMoreField.querySelectorAll('input[type="checkbox"]');
                    checkboxes.forEach(cb => cb.disabled = false);
                }
            }
        }
    };

   if (feedbackTrigger) {
       feedbackTrigger.addEventListener('change', (e) => {
           const selectedValue = e.target.value;
           const defaultLocationId = '165839268277454';
           const conditionalFields = document.querySelectorAll('.js-conditional-field');

           const needsDefaultLocation = selectedValue === 'I have a question' || selectedValue === 'I have a loyalty question';
           
           let hiddenLocationInput = enquiryFormElem.querySelector('input[name="default_location_id"]');
           
           if (needsDefaultLocation) {
               if (!hiddenLocationInput) {
                   hiddenLocationInput = document.createElement('input');
                   hiddenLocationInput.type = 'hidden';
                   hiddenLocationInput.name = 'location_id';
                   hiddenLocationInput.value = defaultLocationId;
                   enquiryFormElem.appendChild(hiddenLocationInput);
               } else {
                   hiddenLocationInput.value = defaultLocationId;
               }
           } else {
               if (hiddenLocationInput) {
                   hiddenLocationInput.remove();
               }
           }

           conditionalFields.forEach(field => {
               const showFor = field.dataset.showFor;

               if (showFor && showFor.split(',').includes(selectedValue)) {
                   field.classList.remove('hidden');

                   const inputs = field.querySelectorAll('input, select, textarea');
                   inputs.forEach(input => {
                       if (input.type === 'checkbox' || input.type === 'radio') {
                           input.disabled = false;
                       } else if (!field.classList.contains('js-location-conditional')) {
                           input.disabled = false;
                       }
                   });
               } else {
                   field.classList.add('hidden');

                   const inputs = field.querySelectorAll('input, select, textarea');
                   inputs.forEach(input => {
                       input.disabled = true;
                       if (input.type === 'checkbox' || input.type === 'radio') {
                           input.checked = false;
                       } else {
                           input.value = '';
                       }
                   });
               }
           });

           if (locationTrigger) {
               locationTrigger.dispatchEvent(new Event('change'));
           }

           updateNegativeExperienceFields();
       });
   }

    if (locationTrigger) {
        locationTrigger.addEventListener('change', (e) => {
            const selectedLocationId = e.target.value;
            const feedbackValue = feedbackTrigger ? feedbackTrigger.value : '';
            const locationConditionalFields = document.querySelectorAll('.js-location-conditional');

            locationConditionalFields.forEach(field => {
                const showForFeedback = field.dataset.showFor;
                const showForLocation = field.dataset.location;
                const excludeLocation = field.dataset.locationExclude;

                let shouldShow = false;

                if (showForFeedback && showForFeedback.split(',').includes(feedbackValue)) {
                    if (showForLocation && showForLocation === selectedLocationId) {
                        shouldShow = true;
                    } else if (excludeLocation && excludeLocation !== selectedLocationId && selectedLocationId !== '') {
                        shouldShow = true;
                    }
                }

                if (shouldShow) {
                    field.classList.remove('hidden');
                    const inputs = field.querySelectorAll('input, select, textarea');
                    inputs.forEach(input => input.disabled = false);
                } else {
                    field.classList.add('hidden');
                    const inputs = field.querySelectorAll('input, select, textarea');
                    inputs.forEach(input => {
                        input.disabled = true;
                        input.value = '';
                    });
                }
            });

            updateNegativeExperienceFields();
        });
    }

   const submitButton = document.querySelector('.js-enquiry-form-submit');

    if (submitButton) {
        submitButton.addEventListener('click', (event) => {
            event.preventDefault();

            const dropdowns = enquiryFormElem.querySelectorAll('select');

            enquiryFormElem.querySelectorAll('.js-enquiry-form-error').forEach(error => {
                error.classList.add('hidden');
            });

            let isValid = true;

            if (enquiryFormElem.checkValidity()) {
                dropdowns.forEach(dropdown => {
                    if (!dropdown.disabled && dropdown.value === '') {
                        isValid = false;
                    }
                });

                if (isValid) {
                    const submitEvent = new Event('submit', {
                        bubbles: true,
                        cancelable: true
                    });
                    enquiryFormElem.dispatchEvent(submitEvent);
                } else {
                    dropdowns.forEach(dropdown => {
                        if (dropdown.value === '') {
                            const errorElem = dropdown.closest('.enquiry-form__input').querySelector('.js-enquiry-form-error');
                            if (errorElem) {
                                errorElem.classList.remove('hidden');
                            }
                        }
                    });
                }
            } else {
                enquiryFormElem.reportValidity();
            }
        });
    }

    if (enquiryFormElem) {
        enquiryFormElem.addEventListener('submit', (e) => {
            e.preventDefault();

            const mod = enquiryFormElem.closest('.enquiry-form');
            const formContainer = mod.querySelector('.enquiry-form__container');
            const formData = new FormData(enquiryFormElem);

            enquiryFormElem.classList.add('opacity-30');
            formContainer.querySelector('.js-popup-loader').classList.remove('hidden');

            const ajaxData = {
                action: 'ajax_guestxm_survey'
            };

            for (const [key, value] of formData.entries()) {
                if (key === 'tell_us_more[]') {
                    if (!ajaxData['tell_us_more']) {
                        ajaxData['tell_us_more'] = [];
                    }
                    ajaxData['tell_us_more'].push(value);
                } else {
                    ajaxData[key] = value;
                }
            }

            runGuestXMFunctions(ajaxData).then((response) => {
                console.log(response);

                const responseContainer = mod.querySelector('.js-enquiry-response-container');
                const responseHeading = responseContainer.querySelector('.js-enquiry-response-heading');
                const responseContent = responseContainer.querySelector('.js-enquiry-response-content');

                responseHeading.textContent = response.heading;
                responseContent.innerHTML = response.content;

                mod.querySelector('.enquiry-form__container').style = 'display: none;';
                mod.querySelector('.enquiry-form__title').classList.add('hidden');

                setTimeout(() => {
                    responseContainer.classList.remove('hidden');
                }, 1000);
            }).catch((error) => {
                console.error('Error submitting form:', error);

                enquiryFormElem.classList.remove('opacity-30');
                formContainer.querySelector('.js-popup-loader').classList.add('hidden');
            });
        });
    }
}